import React from 'react'
import ATHeaderText from '../common/headerText/ATHeaderText'
import ATIconButton from '../common/formComponent/ATIconButton'
import { MdClose } from 'react-icons/md'
import ATTextButton from '../common/formComponent/ATTextButton'
import { FormGroup } from 'react-bootstrap'
import ATInput from '../common/formComponent/ATInput'
import { Form, Formik } from 'formik'
import * as Yup from 'yup'
import { useTranslation } from 'react-i18next'
import {
  CUSTOMER_APPROVAL_STATUS,
  customerAlertFormInitialValues,
} from './customerConstants'
import { TEXT_VALIDATION } from '../../utils/constants/UIConstants'
import { UpdateCustomerRejectStatus } from '../../interface/request/CustomerRequest'
import useCustomerDetails from '../../customHooks/customer/useCustomerDetails'

interface CustomerAlertProps {
  onCloseModal: () => void
  code: string
  setSelectedCustomer: (val: string | undefined) => void
}

const CustomerAlert: React.FC<CustomerAlertProps> = ({
  onCloseModal,
  code,
  setSelectedCustomer,
}) => {
  const { t } = useTranslation(['translation'])
  const { rejectCustomerStatus } = useCustomerDetails()
  return (
    <div className="p-2">
      <ATHeaderText title={t('common.alert')}>
        <ATIconButton
          icon={<MdClose size={16} className="text-dark" />}
          onClick={onCloseModal}
          variant="link"
        />
      </ATHeaderText>
      <div className="mt-3 px-2">{t('customer.alert_message')}</div>
      <div className="px-2">
        <Formik
          validateOnMount={true}
          enableReinitialize
          initialValues={customerAlertFormInitialValues}
          validationSchema={Yup.object({
            reasonDescription: Yup.string()
              .trim()
              .required()
              .min(
                TEXT_VALIDATION.MIN,
                t('common.min_validation', { min_value: TEXT_VALIDATION.MIN }),
              )
              .max(
                TEXT_VALIDATION.MAX,
                t('common.max_validation', { max_value: TEXT_VALIDATION.MAX }),
              ),
          })}
          onSubmit={(values: UpdateCustomerRejectStatus) => {
            rejectCustomerStatus({
              ...values,
              customerCode: code,
              status: CUSTOMER_APPROVAL_STATUS.REJECTED,
            })
            setSelectedCustomer(undefined)
            onCloseModal()
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isValid,
          }) => (
            <Form onSubmit={handleSubmit}>
              <div className="row">
                <FormGroup className="col-12">
                  <ATInput
                    label={t('common.reason')}
                    name="reasonDescription"
                    onChangeHandler={handleChange}
                    onBlurHandler={handleBlur}
                    value={values.reasonDescription}
                    isError={
                      errors.reasonDescription && touched.reasonDescription
                    }
                    error={errors.reasonDescription}
                    placeholder=""
                    isMultiLine={true}
                  />
                </FormGroup>
              </div>
              <div className="d-flex py-3 justify-content-end">
                <ATTextButton
                  title={t('common.no')}
                  onPressHandler={onCloseModal}
                  isFilledButton={false}
                />
                <ATTextButton
                  title={t('common.yes')}
                  onPressHandler={handleSubmit}
                  disabled={!isValid}
                />
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  )
}

export default CustomerAlert
